module.exports = __webpack_public_path__ + "img/SkeletonIcon.03414351.svg";